export const SUPPORTED_LANGUAGES = ['en', 'ru'];

export const DEFAULT_LANGUAGE = 'en';
